module.exports = __webpack_public_path__ + "static/media/icon-header-review.6e33b9b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/HeaderNoLogout/assets/icon-header-review.svg
// module id = 1852
// module chunks = 193